var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 345.18755539924535,
    y: 345.18755539924535,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 36.7,
    width: 13.8,
    y: 39.8,
    x: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 13.8,
    width: 36.7,
    y: 32.9,
    x: 40
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 13.8,
    width: 36.7,
    y: 32.9,
    x: 3.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "currentColor",
    ry: 10.3,
    rx: 10.3,
    cy: 39.8,
    cx: 39.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTConnector);
export default __webpack_public_path__ + "static/media/tConnector.26b785806e92241f77ad36e2f93f7f59.svg";
export { ForwardRef as ReactComponent };